import { HyperliquidInfo } from '@/api/hyperliquid/client/HyperliquidInfo';
import { HyperliquidAgent } from '@/api/hyperliquid/client/HyperliquidAgent';

const BUILDER_CODE = '0x0dF2da2a54AF3A47ba8859D1Bd64690ba69f1dD1';
const BUILDER_INIT_FEE = '0.1%';
const BUILDER_FEE = 25;


const infoClient = new HyperliquidInfo();
const agentClient = new HyperliquidAgent({
  vaultAddress: '',
});

export { infoClient, agentClient };
